import { render } from "./ViewDataPengembalianFormulir.vue?vue&type=template&id=883be1da"
import script from "./ViewDataPengembalianFormulir.vue?vue&type=script&lang=js"
export * from "./ViewDataPengembalianFormulir.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__